export default "__VITE_ASSET__DiZPVaFn__"